export const WATERMARK_EVENTS = {
  CLICKED: 'ai_app_vibe_watermark_clicked',
  CLOSED: 'ai_app_vibe_watermark_closed',
};

export const WATERMARK_TRACKING = {
  INFO1: 'vibe-watermark',
  VIEWER_TYPE_CREATOR: 'app_builder',
  VIEWER_TYPE_VIEWER: 'app_viewer',
  PLACEMENT_EDITOR: 'editor',
  PLACEMENT_LANDING: 'landing_page',
};

export const WATERMARK_LINK_KIND = 'sharable_link';
export const WATERMARK_EDIT_TEXT = 'Edit';
export const WATERMARK_ARIA_LABEL_VIEWER = 'monday vibe';
export const WATERMARK_MONDAY_BASE_URL = 'https://monday.com';
export const WATERMARK_LOGO_URL =
  'https://dapulse-res.cloudinary.com/image/upload/v1759911381/monday_platform/vibe-ai/monday-vibe-logo-small.svg';
